import React from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";

// Данные о преподавателях
const teachersData = [
  {
    id: 1,
    fullName: "Аймаганбетова Анара Муханбеткалиевна",
    position: "Орус тілі мен орыс әдебиеті пән оқытушысы",
    requirement: "Міндетті",
    currentCategory: "Жоғары санат",
    requestedCategory: "Педагог-зерттеуші",
    grantedCategory: "Педагог-зерттеуші",
  },
  {
    id: 2,
    fullName: "Аубакирова Клара Мураткалиевна",
    position: "Арнайы пәндер оқытушысы",
    requirement: "Мерзімінен бұрын",
    currentCategory: "Бірінші санат",
    requestedCategory: "Педагог-сарапшы",
    grantedCategory: "Педагог-сарапшы",
  },
  {
    id: 3,
    fullName: "Конырбаева Гульнара Халесовна",
    position: "Химия пәнінің оқытушысы",
    requirement: "Міндетті",
    currentCategory: "Бірінші санат",
    requestedCategory: "Педагог-зерттеуші",
    grantedCategory: "Педагог-зерттеуші",
  },
];

function CommissionPage() {
  return (
    <Container maxWidth="md" sx={{ marginTop: 12, marginBottom: 4 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Предметно-цикловая комиссия РВТК
        </Typography>
        <Typography variant="h6">01.01.2025</Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          ОТДЕЛЕНИЕ
        </Typography>
        <Typography variant="body1">
          IT-технологий, нефти, газа, экономики и права <br />
          Телекоммуникация и транспорта
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          ПЦК
        </Typography>
        <Typography variant="body1">
          ПЦК информационных, экономических и правовых дисциплин <br />
          ПЦК общеобразовательных дисциплин <br />
          ПЦК технических дисциплин
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                №
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Т.А.Ә
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Лауазымы
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Міндетті/мерзімінен бұрын
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Қолда бар біліктілік санаты
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Өтініш берілген біліктілік санаты
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Берілген біліктілік санаты
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teachersData.map(teacher => (
              <TableRow key={teacher.id}>
                <TableCell align="center">{teacher.id}</TableCell>
                <TableCell align="center">{teacher.fullName}</TableCell>
                <TableCell align="center">{teacher.position}</TableCell>
                <TableCell align="center">{teacher.requirement}</TableCell>
                <TableCell align="center">{teacher.currentCategory}</TableCell>
                <TableCell align="center">
                  {teacher.requestedCategory}
                </TableCell>
                <TableCell align="center">{teacher.grantedCategory}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}

export default CommissionPage;
